import { PositionHistoryData } from 'data/Historical/positions/types'
import fetchApi from 'utils/fetchApi'
import { getApiUrl } from 'utils/urlBuilder'

const PAGE_SIZE = 50
export const history = (nextPath?: string) =>
  fetchApi<PositionHistoryData>({
    auth: true,
    body: { limit: PAGE_SIZE },
    method: 'POST',
    url: getApiUrl(`nabu-gateway/positions/history${nextPath ?? ''}`)
  })
